export default class ArrauUtils {
    public static findLastIndex<T>(array: Array<T>, findLastFunc: (d: T) => boolean): number {
        for (let i = array.length - 1; i >= 0; i--) {
            if (findLastFunc(array[i])) {
                return i
            }
        }
        return -1;
    }
}